<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col cols="12" sm="6" md="4">
        <v-card :loading="isLoading" :disabled="isLoading">
          <v-card-title>
            <v-row justify="space-between">
              <span class="font-weight-light" style="font-size: 16pt">{{ $t('label.changePassword') }}</span>
            </v-row>
          </v-card-title>
          <v-form v-model="isFormValid" ref="changePasswordForm" autocomplete="off" @submit.prevent="">
            <v-card-text>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="user.vendorCode"
                    :rules="[rules.required(user.vendorCode, $t('rule.required.vendorCode'))]"
                    :label="$t('label.vendorCode')"
                    prepend-inner-icon="mdi-account-box"
                    name="vendorCode"
                    autocomplete="off"
                    outlined
                    dense>
                  </v-text-field>
                </v-col>
                <v-col cols="12">
                    <v-text-field
                      v-model="user.password"
                      :rules="[rules.required, rules.minCharacters(user.password, 8)]"
                      :label="$t('label.newPassword')"
                      prepend-inner-icon="mdi-lock"
                      :append-icon="showNewPassword ? 'mdi-eye-off': 'mdi-eye'"
                      :type="showNewPassword ? 'text' : 'password'" @click:append="showNewPassword = !showNewPassword" name="newPassword" outlined dense>
                    </v-text-field>
                </v-col>
                <v-col cols="12">
                    <v-text-field
                      v-model="user.repeatPassword"
                      :rules="[rules.required, rules.repeatPassword(user.password, user.repeatPassword)]"
                      :label="$t('label.repeatNewPassword')"
                      prepend-inner-icon="mdi-lock"
                      :append-icon="showRepeatNewPassword ? 'mdi-eye-off': 'mdi-eye'"
                      :type="showRepeatNewPassword ? 'text' : 'password'" @click:append="showRepeatNewPassword = !showRepeatNewPassword" name="repeatNewPassword" outlined dense>
                    </v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn small depressed @click.stop="resetPassword" color="primary" :loading="isLoading" :disabled="!isFormValid">{{ $t('label.continue') }}</v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { loading, rules, showMessage, userInfo } from '../mixins'
import axios from 'axios'

export default {
  name: 'ResetPasswordPage',
  mixins: [loading, rules, showMessage, userInfo],
  data: () => ({
    isFormValid: null,
    showNewPassword: false,
    showRepeatNewPassword: false,
    user: {
      vendorCode: '',
      password: '',
      repeatPassword: ''
    }
  }),
  methods: {
    confirmationChangePassword (confirm) {
      this.isConfirmationChangePasswordDialogOpen = false
      if (confirm) {
        this.resetPassword()
      }
    },
    resetPassword () {
      this.changeLoadingStatus(true)
      axios.defaults.headers.common.Authorization = `Bearer ${this.$route.params.token}`
      this.$proxy.post('api/vendors/resetpassword', this.user)
        .then((r) => {
          this.showMessage(this.$t('message.success.passwordChanged'))
          this.clearForm()
          this.$router.push({ name: 'login' })
        })
        .catch((e) => {
          if (e.response.status === 401) {
            this.showMessage(this.$t('message.error.invalidToken'))
          } else {
            this.showHttpErrorMessage(e)
          }
        })
        .finally(() => {
          this.changeLoadingStatus(false)
          if (typeof axios.defaults.headers.common.Authorization !== 'undefined') {
            axios.defaults.headers.common.Authorization = null
          }
        })
    },
    clearForm () {
      this.user = {
        password: '',
        repeatPassword: ''
      }
      this.showNewPassword = false
      this.showRepeatNewPassword = false
      this.$refs.changePasswordForm.resetValidation()
    }
  }
}
</script>

<style >
</style>
